import FolioCheckbox from '@/components/FolioCheckbox';
import { getPolicyTransactionInvoiceLabel } from '@/utils/policyTransactionLabel';
import { SelectPolicyTransactionTable } from '@/components/tables/SelectPolicyTransactionTable';
import { Box, Chip, FormHelperText, FormLabel, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';

const DebtorPolicyTransactionSelect = () => {
	const { values, errors, setFieldValue } = useFormikContext();

	const [displayAllTransactions, setDisplayAllTransactions] = useState(false);
	const hasTransactionError = Boolean(errors.transactions);

	return (
		<Stack>
			<Stack justifyContent='space-between' direction='row' alignItems='center'>
				<Stack direction='column'>
					<FormLabel required error={hasTransactionError}>
						{'Policy transactions'}
					</FormLabel>
					<FormHelperText sx={{ ml: 0 }} error={hasTransactionError}>
						Select one or more policy transactions for this Debtor
					</FormHelperText>
				</Stack>

				<Box mt={3} maxWidth='250px'>
					<FolioCheckbox
						checked={displayAllTransactions}
						onChange={(e) => setDisplayAllTransactions(e.target.checked)}
						size='small'
						label='Display $0.00 invoices'
					/>
				</Box>
			</Stack>

			{values.transactions?.length > 0 && (
				<Stack
					direction='row'
					spacing={1}
					flexWrap='wrap'
					sx={{ mb: 1 }}
					alingnItems='center'
				>
					<Typography variant='subtitle2'>Selected invoice(s)</Typography>
					{values.transactions.map((t) => {
						const id = t.policyTransId ?? t.Id;
						const invoiceLabel = getPolicyTransactionInvoiceLabel(t);
						const chipLabel =
							invoiceLabel === 'Take up' || invoiceLabel === 'Draft'
								? invoiceLabel
								: `Invoice ${invoiceLabel}`;

						return (
							<Chip
								key={id}
								color='primary'
								label={chipLabel}
								onDelete={() => {
									const updated = values.transactions.filter(
										(x) => (x.policyTransId ?? x.Id) !== id,
									);
									setFieldValue('transactions', updated);
								}}
								size='small'
							/>
						);
					})}
				</Stack>
			)}

			<SelectPolicyTransactionTable
				showDisabledRows={true}
				clientId={values.insightId}
				transactions={values.transactions}
				setSelectedTransactions={(transactions) =>
					setFieldValue('transactions', transactions)
				}
				displayAllTransactions={displayAllTransactions}
				type='invoice'
			/>
			{hasTransactionError && <FormHelperText error>{errors.transactions}</FormHelperText>}
		</Stack>
	);
};
export default DebtorPolicyTransactionSelect;
